import {ReleaseTogglesType} from "./ReleaseToggles";
import {get} from "../core/api";
import {RELEASE_TOGGLE_ALL_OFF} from "./ReleaseTogglesTestSupport";

export const getReleaseToggles = (): Promise<ReleaseTogglesType> => {
    return get(`/v1/releaseToggles`).then((res: Response) => {
        if (res.status === 200 || res.status === 201) {
            return res.json();
        } else {
            return RELEASE_TOGGLE_ALL_OFF;
        }
    }).catch(()=> {
        return RELEASE_TOGGLE_ALL_OFF
    })
}
export const getLaunchDarklyFlag = async (flagName: string): Promise<boolean> => {
    const res = await get(`/featureflags/features?featureFlag=${flagName}`);
    if (res.status === 200 || res.status === 201) {

        const promise = res.json();
        console.log(`launch darkly response ${flagName} is ${promise}`);
        return promise;
    } else {
        return false;
    }
}

export const releaseToggleApiClient = {
    getReleaseToggles,
    getLaunchDarklyFlag,
}